export const ANNUAL_LEAVE_LIST = "ANNUAL_LEAVE_LIST";
